import React from 'react';
import '../../styles/App.css';
import weiboLogo from '../../images/weibo-icon-88.png';
import wechatLogo from '../../images/wechat-icon-88.png';
import sticker from '../../images/sticker.png';
import App from "../../scenes/App";

let tr = require( '../../utils/translations' ).translate;

// STATIC FUNCTIONS
// =================================================================================================


// MAIN REACT CLASS DECLARATION
// =================================================================================================
class Options extends React.Component {


	// REACT APP CONSTRUCTOR
	// =============================================================================================
	constructor( props ) {

		super( props );
	};


	// MAIN RENDER METHOD
	// =============================================================================================
	render() {

		let AppState = this.props.App.state,
			VideoScene = this.props.VideoScene,
			size = 0;

		// GET ESTIMATION OF GIF FILE SIZE
		if ( !AppState.saveFrames && AppState.images && AppState.images.length
			&& ( AppState.images.length === VideoScene.receivedMessageCount ) ) {
			AppState.images.forEach( function ( img ) {

				let head = 'data:image/gif;base64,';
				size += Math.round( ( img.length - head.length ) * 3 / 4 );
			} );

			size = ( size / 1000000 * 5 ).toFixed( 2 );

		} else size = false;


		{/*VIDEO META INFORMATION AND BUTTONS*/}
		{/*--------------------------------------------------------------------------------------*/}
		return <div className="video-meta-options">

			<p>{tr( 'Estimated Size:', '估算大小' )}<span>{size ? size + 'MB' :
				<div className="spinner spinner-small"/>}</span></p>

			<div className="compatible-container">

				<div className="compatible-images">

					<div
						data-tooltip={tr( 'Weibo images need to be less than 4MB.', '微博贴图大小不能超过4mb' )}>
						<img width={32} height={32} src={weiboLogo} style={{
							opacity: size && size < 5 ? 1 : 0.2
						}}/>
						<p>{tr( 'Weibo', '微博' )}</p>

						<div
							className={( size < 5 ? 'tick' : 'cross' ) + ( size ? '' : ' grey' )}/>
					</div>

					<div
						data-tooltip={tr( 'WeChat Article images need to be less than 2MB.', '微信文章贴图大小不能超过2mb' )}>
						<img width={32} height={32} src={wechatLogo} style={{
							opacity: size && size < 2 ? 1 : 0.2
						}}/>
						<p>{tr( 'WeChat Article', '微信文章' )}</p>

						<div
							className={( size < 2 ? 'tick' : 'cross' ) + ( size ? '' : ' grey' )}/>
					</div>

					<div
						data-tooltip={tr( 'WeChat Stickers need to be less than 1MB.', '微信表情包大小不能超过0.3mb' )}>
						<img width={32} height={32} src={sticker} style={{
							opacity: size && size < 1 ? 1 : 0.2
						}}/>
						<p>{tr( 'WeChat Sticker', '微信表情包' )}</p>

						<div
							className={( size < 1 ? 'tick' : 'cross' ) + ( size ? '' : ' grey' )}/>
					</div>

				</div>
			</div>
		</div>
	}
}

export default Options;



// WEBPACK FOOTER //
// ./src/app/components/video/options.js